export const TRANSACTION_RECEIPT_EVENT = "mktransfe:transaction-receipt";

const clean = (value) => {
    if (value === null || value === undefined) return "";
    return String(value).trim();
};

const numberOrNull = (value) => {
    if (value === null || value === undefined || value === "") return null;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
};

const parseRequestBody = (value) => {
    if (!value) return {};
    if (typeof value === "object") return value;
    if (typeof value !== "string") return {};
    try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === "object" ? parsed : {};
    } catch {
        return {};
    }
};

const unwrap = (data) => {
    if (!data || typeof data !== "object") return {};

    const candidates = [
        data.transaction,
        data.transfer,
        data.deposit,
        data.withdrawal,
        data.payment,
        data.order,
        data.card,
        data.result,
        data.data,
    ];

    for (const candidate of candidates) {
        if (candidate && typeof candidate === "object" && !Array.isArray(candidate)) {
            return { ...data, ...candidate };
        }
    }

    return data;
};

const endpointService = (url = "") => {
    const path = clean(url).toLowerCase();

    if (path.includes("/wallet/deposits")) return "Depo MKTRANSFE";
    if (path.includes("/deposits/kobara/create")) return "Depo MonCash/NatCash";
    if (path.includes("/partner/v1/deposits/bhd")) return "Depo BHD";
    if (path.includes("/wallet/withdrawals")) return "Retrè MKTRANSFE";
    if (path.includes("/wallet/transfers")) return "Transfè Wallet";
    if (path.includes("/client/transfers")) return "Transfè MKTRANSFE";
    if (path.includes("/transfers/custom")) return "Transfè MKTRANSFE";
    if (path.includes("/recharge/purchase")) return "Rechaj Telefòn";
    if (path.includes("/ht/minutes")) return "MK Recarga";
    if (path.includes("/recargas-dominicanas")) return "Recargas Dominicana";
    if (path.includes("/bills/") && path.endsWith("/pay")) return "Peman Fakti";
    if (path.includes("/cards/request")) return "Kat Visa MKTRANSFE";
    if (path.includes("/cards/recharge")) return "Rechaj Kat Visa";
    if (path.includes("/cards/") && path.includes("/fund")) return "Fund Kat Visa";
    if (path.includes("/partner/v1/cards")) return "Kat Visa Partner";
    if (path.includes("/mk-api/cards")) return "Kat Visa MK API";
    if (path.includes("/partner/v1/moncash/transfers")) return "MonCash";
    if (path.includes("/partner/v1/automatic-transfers")) return "Transfè Otomatik";
    if (path.includes("/partner/v1/manual-transfers")) return "Transfè Partner";
    if (path.includes("/partner/commission/swap")) return "Konvèsyon Komisyon";
    if (path.includes("/wizzgift/iframe/pay")) return "Gift Card";
    if (path.includes("/digital-products/international/orders")) return "MK Digital Entènasyonal";
    if (path.includes("/digital-products/orders")) return "MK Digital";
    if (path.includes("/streaming/subscriptions")) return "Streaming";
    if (path.includes("/internet/access-request")) return "MK VPN";
    if (path.includes("/recarga/purchase")) return "Recarga";
    if (path.includes("/nowpayments/operations")) return "Kripto";
    if (path.includes("/p2p-whatsapp/partner/requests")) return "P2P Echanj";
    if (path.includes("/partner/v1/method-transfers")) return "Transfè patnè";
    if (path.includes("/partner/v1/unelma-transfers")) return "Transfè USD";
    if (path.includes("/crypto/requests")) return "Crypto";
    if (path.includes("/manual-shop/orders")) return "Demann Acha";
    if (path.includes("/exchange/convert")) return "Konvèsyon";
    if (path.includes("/investor") && path.includes("withdraw")) return "Retrè Envestisè";
    if (path.includes("/admin/wallet-deposits")) return "Revizyon Depo";
    if (path.includes("/admin/wallet-withdrawals")) return "Revizyon Retrè";
    if (path.includes("/admin/partner-bhd-deposits")) return "Revizyon Depo Partner";
    if (path.includes("/operator/requests")) return "Konfimasyon Operasyon";

    return "MKTRANSFE";
};

const normalizeStatus = (value, url = "") => {
    const raw = clean(value).toUpperCase();
    if (raw) return raw;

    const path = clean(url).toLowerCase();
    if (path.includes("/prepare")) return "AWAITING_RECEIPT";
    if (path.includes("/receipt")) return "PENDING_REVIEW";
    if (path.includes("/freeze")) return "COMPLETED";
    if (path.includes("/unfreeze")) return "COMPLETED";
    if (path.includes("/status")) return "COMPLETED";
    if (path.includes("/partner/commission/swap")) return "COMPLETED";
    if (path.includes("/recharge/purchase")) return "COMPLETED";
    if (path.includes("/recargas-dominicanas/")) return "COMPLETED";
    if (path.includes("/wizzgift/iframe/pay")) return "COMPLETED";
    if (/\/(approve|confirm)$/.test(path)) return "COMPLETED";
    if (/\/reject$/.test(path)) return "REJECTED";

    return "PENDING";
};

const TRANSACTION_PATTERNS = [
    /\/recarga\/purchase$/,
    /\/nowpayments\/operations$/,
    /\/p2p-whatsapp\/partner\/requests$/,
    /\/partner\/v1\/method-transfers$/,
    /\/partner\/v1\/unelma-transfers$/,
    /\/client\/transfers$/,
    /\/transfers\/custom$/,
    /\/wallet\/transfers$/,
    /\/wallet\/deposits$/,
    /\/wallet\/deposits\/[^/]+\/receipt$/,
    /\/wallet\/deposits\/[^/]+\/cancel$/,
    /\/wallet\/deposits\/binance-wallet$/,
    /\/wallet\/deposits\/binance-pay$/,
    /\/partner\/v1\/deposits\/bhd$/,
    /\/wallet\/withdrawals$/,
    /\/wallet\/withdrawals\/kobara$/,
    /\/wallet\/withdrawals\/binance-pay$/,
    /\/wallet\/withdrawals\/binance-onchain$/,
    /\/recharge\/purchase$/,
    /\/recargas-dominicanas\/(recharge|data-plan|pin|pay-invoice|service-topup)$/,
    /\/bills\/[^/]+\/pay$/,
    /\/cards\/request$/,
    /\/cards\/recharge$/,
    /\/cards\/me\/status$/,
    /\/cards\/[^/]+\/(fund|freeze|unfreeze)$/,
    /\/partner\/v1\/cards$/,
    /\/mk-api\/cards$/,
    /\/partner\/v1\/cards\/[^/]+\/fund$/,
    /\/partner\/v1\/cards\/[^/]+\/status$/,
    /\/partner\/v1\/moncash\/transfers$/,
    /\/partner\/v1\/automatic-transfers$/,
    /\/partner\/v1\/manual-transfers$/,
    /\/partner\/commission\/swap$/,
    /\/wizzgift\/iframe\/pay$/,
    /\/digital-products\/(international\/)?orders$/,
    /\/streaming\/subscriptions$/,
    /\/streaming\/subscriptions\/[^/]+\/cancel$/,
    /\/internet\/access-request$/,
    /\/crypto\/requests$/,
    /\/manual-shop\/orders$/,
    /\/manual-shop\/orders\/[^/]+\/(accept|cancel)$/,
    /\/exchange\/convert$/,
    /\/deposits\/kobara\/create$/,
    /\/ht\/minutes$/,
    /\/investor-agent\/transfers\/[^/]+\/(claim|complete|cancel|unlock)$/,
    /\/investor-agent\/minutes$/,
    /\/v2\/investor\/withdrawals$/,
    /\/admin\/investor-agents\/[^/]+\/earnings-withdraw$/,
    /\/admin\/wallet-(deposits|withdrawals)\/[^/]+\/(approve|reject)$/,
    /\/admin\/partner-bhd-deposits\/[^/]+\/(approve|reject)$/,
    /\/operator\/requests\/[^/]+\/[^/]+\/(confirm|reject)$/,
];

export function shouldOpenOfficialReceipt(config = {}) {
    if (config?.skipOfficialReceipt === true) return false;

    const method = clean(config?.method || "GET").toUpperCase();
    if (!["POST", "PUT", "PATCH", "DELETE"].includes(method)) return false;

    const rawUrl = clean(config?.url || "");
    const path = rawUrl.split("?")[0].replace(/^https?:\/\/[^/]+/i, "");

    return TRANSACTION_PATTERNS.some((pattern) => pattern.test(path));
}

export function buildOfficialReceiptPayload(response) {
    const config = response?.config || {};
    const rawData = response?.data;
    const data = unwrap(rawData);
    const request = parseRequestBody(config?.data);
    const url = clean(config?.url || "");

    const pathParts = url.split("?")[0].split("/").filter(Boolean);
    const receiptUrlMatch = url.match(/\/wallet\/deposits\/([^/]+)\/receipt(?:\?|$)/i);

    const reference = clean(
        data.reference ||
        data.paymentReference ||
        data.transferId ||
        data.depositId ||
        data.withdrawalId ||
        data.transactionId ||
        data.providerReference ||
        data.providerTransactionId ||
        data.providerRequestId ||
        data.orderId ||
        data.txId ||
        data.id ||
        receiptUrlMatch?.[1] ||
        request.reference ||
        request.requestId ||
        request.externalId ||
        ""
    );

    const service = clean(
        data.service ||
        data.serviceName ||
        data.methodName ||
        data.productName ||
        data.product ||
        data.operationType ||
        endpointService(url) ||
        data.type
    );

    const currency = clean(
        (request.amountUsd !== undefined && request.amountUsd !== null
            ? (data.fees?.currency || data.cardCurrency || "USD")
            : "") ||
        data.providerCurrency ||
        data.currency ||
        data.walletCurrency ||
        data.debitCurrency ||
        data.fees?.currency ||
        request.currency ||
        (url.includes("cards") ? "USD" : "")
    ).toUpperCase();

    const amount = numberOrNull(
        data.amount ??
        data.amountDop ??
        data.netAmount ??
        data.amountUsd ??
        data.requestedAmount ??
        data.fees?.amount ??
        request.amount ??
        request.amountUsd
    );

    const fee = numberOrNull(
        data.fee ??
        data.feeDop ??
        data.bankFee ??
        data.creationFee ??
        data.creation_fee ??
        data.fees?.creation_fee ??
        data.fees?.fee ??
        0
    );

    const total = numberOrNull(
        data.total ??
        data.totalDebitDop ??
        data.totalDebit ??
        data.totalDebited ??
        data.expectedReceiptTotal ??
        data.fees?.total_debit ??
        null
    );

    const receiveAmount = numberOrNull(
        data.receiveAmount ??
        data.receiveAmountHtg ??
        data.creditedAmount ??
        data.creditAmount ??
        data.gourdes ??
        data.netAmountReceived ??
        null
    );

    const receiveCurrency = clean(
        data.receiveCurrency ||
        data.creditCurrency ||
        (data.receiveAmountHtg !== undefined && data.receiveAmountHtg !== null ? "HTG" : "") ||
        (data.gourdes !== undefined && data.gourdes !== null ? "HTG" : "") ||
        data.walletCurrency ||
        data.targetCurrency ||
        ""
    ).toUpperCase();

    const number = clean(
        data.beneficiaryPhone ||
        data.phone ||
        data.phoneNumber ||
        data.target ||
        data.accountNumber ||
        data.payId ||
        data.address ||
        request.beneficiaryPhone ||
        request.phone ||
        request.phoneNumber ||
        request.number ||
        request.accountNumber ||
        request.payId ||
        request.address ||
        ""
    );

    const beneficiary = clean(
        data.beneficiaryName ||
        data.accountName ||
        data.recipientName ||
        data.nameOnCard ||
        data.name_on_card ||
        request.beneficiaryName ||
        request.accountName ||
        ""
    );

    const extraRows = [];
    const addExtra = (label, value) => {
        if (value === null || value === undefined || value === "") return;
        extraRows.push({ label, value: String(value) });
    };

    addExtra("Metòd", data.methodName || data.method || request.methodName);
    addExtra("Rezo", data.network || request.network);
    addExtra("TxID", data.txId || data.transactionHash || data.hash);
    addExtra("Kont", data.accountNumber || request.accountNumber);
    addExtra("Email", data.email || data.beneficiaryEmail || request.email || request.beneficiaryEmail);
    addExtra("Node ID", data.nodeId || data.node_id || request.nodeId || request.node_id);
    addExtra("Network ID", data.networkId || data.network_id || request.networkId || request.network_id);
    addExtra("Wallet", data.walletCurrency || data.debitCurrency);

    return {
        service,
        status: normalizeStatus(
            data.status ||
            data.providerStatus ||
            (String(data.kycStatus || "").toUpperCase() === "PENDING" ? "KYC_PENDING" : "") ||
            rawData?.status,
            url
        ),
        reference,
        number,
        beneficiary,
        amount,
        currency,
        fee,
        total,
        totalCurrency: clean(data.totalCurrency || data.debitCurrency || currency).toUpperCase(),
        receiveAmount,
        receiveCurrency,
        exchangeRate: numberOrNull(data.exchangeRate ?? data.rate ?? data.conversionRate),
        product: clean(data.productName || data.product || ""),
        plan: clean(data.planName || data.plan || ""),
        createdAt: data.createdAt || data.created_at || data.timestamp || new Date().toISOString(),
        extraRows,
        message: clean(data.message || rawData?.message || ""),
        sourceUrl: url,
        requestMethod: clean(config?.method || "POST").toUpperCase(),
        raw: data,
        _pathParts: pathParts,
    };
}

export function buildOfficialReceiptErrorPayload(error) {
    const responseData = error?.response?.data || {};
    const detail = responseData?.detail;
    const detailObject = detail && typeof detail === "object" ? detail : {};
    const code = clean(
        detailObject.code ||
        responseData.code ||
        responseData.error?.code ||
        ""
    ).toUpperCase();
    const responseStatus = clean(
        responseData.status ||
        detailObject.status ||
        responseData.error?.status ||
        ""
    ).toUpperCase();

    const isDomainFailure =
        ["FAILED", "REJECTED", "DECLINED", "CANCELLED", "CANCELED"].includes(responseStatus) ||
        /(REJECTED|DECLINED|DISCONTINUED|PROVIDER_FAILED|TRANSACTION_FAILED)/.test(code);

    if (!isDomainFailure || !shouldOpenOfficialReceipt(error?.config || {})) {
        return null;
    }

    const message = clean(
        detailObject.message ||
        responseData.error?.message ||
        (typeof detail === "string" ? detail : "") ||
        "Operasyon an pa t finalize avèk siksè."
    );

    const synthetic = {
        config: error.config,
        data: {
            status: responseStatus || "REJECTED",
            message,
            reference:
                detailObject.reference ||
                responseData.reference ||
                "",
        },
    };

    return buildOfficialReceiptPayload(synthetic);
}


export function emitOfficialReceipt(payload) {
    if (typeof window === "undefined" || !payload) return;
    window.dispatchEvent(
        new CustomEvent(TRANSACTION_RECEIPT_EVENT, {
            detail: payload,
        })
    );
}
